/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"

class Bio extends React.Component {
  render() {
    let author = this.props.author 
    return (
      <div className="flex mb-3">
        <img
          src={author.avatar.src}
          alt={author.email}
          className="mr-4 mb-0 rounded-full h-50 w-50"
        />
        <p>
          { author.bio }
        </p>
      </div>
    )
  }
}

export default Bio

